module.exports = {
  h: {
    empty: {
      noData: '暂无数据'
    }
  }
};
